module.exports = __webpack_public_path__ + "img/program-photo_neos.47041b4a.jpg";